import { OidcProvider as OriginalOidcProvider } from "@axa-fr/react-oidc";
import { FC, PropsWithChildren, useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { IdpConfiguration, OidcAppConfiguration } from "../../types/oidcTypes";
import { getOidcConfiguration } from "../../utils/oidcConfiguration";
import { persistPreAuthenticationPathIfNoneIsSet } from "../../utils/oidcUtils";
import { OidcAuthenticating, OidcAuthenticationError, OidcCallbackSuccess, OidcLoading, OidcSessionLost } from "./OidcStateComponents";

export interface OidcProviderProps {
  idpConfiguration: IdpConfiguration;
  oidcAppConfiguration: OidcAppConfiguration;
}

export const OidcProvider: FC<PropsWithChildren<OidcProviderProps>> = ({ children, idpConfiguration, oidcAppConfiguration }) => {
  const configuration = useMemo(
    () => getOidcConfiguration(idpConfiguration, oidcAppConfiguration),
    [idpConfiguration, oidcAppConfiguration],
  );

  const navigate = useNavigate();
  const onSessionLost = useCallback(
    () => {
      persistPreAuthenticationPathIfNoneIsSet();
      navigate(oidcAppConfiguration.pathLogout);
    },
    [navigate, oidcAppConfiguration.pathLogout],
  );

  return (
    <OriginalOidcProvider
      configurationName={oidcAppConfiguration.oidcContext}
      configuration={configuration}
      onSessionLost={onSessionLost}
      onLogoutFromAnotherTab={onSessionLost}
      sessionLostComponent={OidcSessionLost}
      authenticatingComponent={OidcAuthenticating}
      authenticatingErrorComponent={OidcAuthenticationError}
      callbackSuccessComponent={OidcCallbackSuccess}
      loadingComponent={OidcLoading}
    >
      {children}
    </OriginalOidcProvider>
  );
};
